<template>
  <button 
    type="button" 
    class="btn" 
    :class="{
      'btn-sm': (size == 'usm') || (size == 'sm'), 
      'btn-md': size == 'md', 
      'btn-lg': size == 'lg', 
      'btn-light': color == 'light', 
      'btn-primary': color == 'primary', 
      'btn-secondary': color == 'secondary', 
      'btn-success': color == 'success', 
      'btn-info': color == 'info', 
      'btn-warning': color == 'warning', 
      'btn-danger': color == 'danger', 
      'btn-dark': color == 'dark', 
      'btn-light-primary': color == 'light-primary'
    }" 
    :disabled="(disabled) || (isLoading)" 
    :style="{
      'width': width ? width : (block ? '100%' : ''), 
      'padding': size == 'usm' ? '2px 6px !important' : '',
      'white-space': width ? 'nowrap' : '',
      'overflow': width ? 'hidden' : '',
      'text-overflow': width ? 'ellipsis' : '',
      'font-size': size == 'usm' ? '11px !important' : '',
    }" 
    :data-bs-toggle="databstoggle" 
    :data-bs-target="databstarget"
    @click="$emit('click', $event)"
  >
    <span class="indicator-label">
      <i v-if="iconeAcao" class="las" :class="iconeAcao" aria-hidden="true" style="font-size: 16px;"></i>
      {{ label }}
      <span 
        v-if="isLoading" 
        class="spinner-border spinner-border-sm align-middle ms-2"
      ></span>
    </span>
  </button>
</template>

<script>
export default {
  name: "ButtonPadrao",
  emits: ["click"],
  props: [
    "label", 
    "disabled", 
    "isLoading", 
    "size", 
    "width",
    "color", 
    "block", 
    "databstoggle", 
    "databstarget"
  ],
  computed: {
    iconeAcao() {
      const normalizar = valor => String(valor || '').trim().toLocaleLowerCase();
      const label = normalizar(this.label);
      const acoes = { Buscar: 'la-search', Imprimir: 'la-print', 'Exportar CSV': 'la-file-csv' };
      for (const [texto, icone] of Object.entries(acoes)) {
        const traducao = typeof this.$t === 'function' ? this.$t(texto) : texto;
        if (label === normalizar(texto) || label === normalizar(traducao)) return icone;
      }
      return '';
    }
  },
  methods: {
  }
}
</script>

<style>

</style>
